import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import './Salts.css'
import Gettouch from "../../../../components/getTouch/Gettouch";
import crystalSaltImg from '../../../../assets/crystalSaltImg.webp'
import freeFlowImg from '../../../../assets/freeFlowImg.webp';
import fineSaltImg from '../../../../assets/fineSaltImg.webp'
import ppm150Img from '../../../../assets/ppm150Img.webp'
import ppm50Img from '../../../../assets/ppm50Img.webp'
import mesh40 from '../../../../assets/mesh40.webp'


const saltData = {
    'Refined Salt': {
        description: 'Refined Salt, also known as sodium chloride (NaCl), is one of the purest forms of salt. Carefully processed and free from impurities, it is widely used in food production, pharmaceuticals, and chemical manufacturing. This salt is essential for maintaining proper fluid balance in the body and plays a vital role in various industrial applications. Our refined salt is available in various grain sizes and packaging options, ensuring tailored solutions for every need.',
        image: require('../../../../assets/crystalSaltImg.webp')
    },
    'Crystal Salt': {
        description: (
            <>
                Crystal Salt is naturally harvested from salt deposits,
                known for its coarse texture and rich mineral content.
                It retains trace minerals that give it a unique flavor and is often used as a finishing salt or in salt grinders.
                The natural crystallization process makes it a preferred choice for
                culinary enthusiasts and chefs who seek a more organic and flavorful
                alternative to traditional salts. We specialize in providing premium-grade crystal salt for use in <strong>Textile Industry</strong> & <strong>RO Industry</strong>.
            </>
        ),
        image: require('../../../../assets/crystalSaltImg.webp')
    },
    'Free Flow (medium)': {
        description: (
            <>
                Free Flow (Medium) Salt is processed to prevent clumping, making it perfect for industrial packaging and applications.
                Its flow-enhancing properties make it ideal for large-scale manufacturing, ensuring a smooth and consistent flow during production.
                This type of salt is commonly used in food processing, packaging, and other industrial applications where ease of handling is crucial.
                We specialize in providing premium-grade Free Flow C medium for use in <strong>Soap Industry</strong> & <strong>Chemical Industry</strong>.
            </>
        ),
        image: require('../../../../assets/freeFlowImg.webp')
    },
    'Fine Salt': {
        description: (
            <>
                Fine Salt has a smaller particle size, making it ideal for applications such as snacks, bakery products, and food seasonings.
                Its fine texture allows it to dissolve quickly and evenly, enhancing the flavor of the food it is added to. This salt is
                perfect for delicate recipes and is used in a wide range of culinary products.
                We specialize in providing premium-grade Fine Salts for use in <strong>Chemical Industry</strong>.
            </>
        ),
        image: require('../../../../assets/fineSaltImg.webp')
    },
    '150 PPM Salt': {
        description: (
            <>
                150 PPM Salt is specifically designed to meet the iodine deficiency needs in certain regions.
                With 150 parts per million (PPM) of iodine, it is a critical resource for public health,
                especially in areas where iodine deficiency is prevalent.
                This salt helps prevent iodine deficiency disorders and ensures that people receive the necessary iodine intake for proper thyroid function.
                We specialize in providing premium-grade 150 PPM Salt for use in <strong>Textile Industry</strong> & <strong>Dyes Industry</strong>.
            </>
        ),

        image: require('../../../../assets/ppm150Img.webp')
    },
    '40 Mesh Salt': {
        description: (
            <>
                40 Mesh Salt is ground to a specific mesh size, commonly used in seasoning blends and processed foods.
                Its granular texture is ideal for sprinkling over food products or blending into seasonings, ensuring a uniform distribution of salt.
                This type of salt is commonly found in industrial kitchens, restaurants, and food production lines.

            </>
        ),
        image: require('../../../../assets/mesh40.webp')
    },
    '50 PPM Salt': {
        description: (
            <>
                50 PPM Salt is a type of salt with lower iodine content, typically used for specific dietary or industrial requirements.
                It is perfect for customers seeking a salt with controlled iodine levels for customized health or manufacturing purposes.
                This salt helps meet particular dietary needs without the high iodine concentration found in regular iodized salt.

            </>
        ),
        image: require('../../../../assets/ppm50Img.webp')
    },
    'Iodised Salt': {
        description: (
            <>
                Iodised Salt is enriched with iodine to help prevent iodine deficiency disorders,
                commonly found in households and food manufacturing.
                Iodine is an essential nutrient that supports thyroid health and metabolism.
                This salt is widely used in homes, restaurants, and food production,
                ensuring that individuals get their daily intake of iodine through a common dietary ingredient.
            </>
        ),
        image: require('../../../../assets/crystalSaltImg.webp')
    }
};



const Salts = () => {
    const location = useLocation();
    const [selectedSalt, setSelectedSalt] = useState('Refined Salt');

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const itemParam = searchParams.get('item') || searchParams.get('type');
        if (itemParam) {
            const keys = Object.keys(saltData);
            const match = keys.find(k => k.toLowerCase().includes(itemParam.toLowerCase()) || itemParam.toLowerCase().includes(k.toLowerCase()));
            if (match) {
                setSelectedSalt(match);
            }
        }
    }, [location.search]);


    return (
        <>
            <div className="Salt-Page-Desktop">
                <div className="Salt-Main-Container">
                    <div className="Salt-Sub-Container">
                        <h1>Salts</h1>
                        <p>Salt, also known as sodium chloride (NaCl), is one of
                            the most essential and widely used minerals on Earth.
                            More than just a seasoning, salt is a cornerstone of
                            life and industry. From maintaining the body’s
                            natural balance to enabling complex manufacturing
                            processes, its applications span far and wide.

                            At Chemi-Salt , we provide high-purity salt
                            products that are meticulously extracted, refined,
                            and quality-checked to meet the demands of a diverse range of industries.
                            Whether used in food production, pharmaceuticals, chemical manufacturing,
                            or agriculture, our salt delivers reliability, consistency, and superior performance.
                            We understand that not all salt is the same. That’s why we offer customized solutions based on grain size,
                            purity level, and packaging — ensuring every customer gets exactly what they need.

                        </p>
                    </div>

                    <div className="Salt-Types-Main-Container">
                        <div className="Salt-Types-List-Conatiner">
                            <h1>Types Of Salt</h1>
                            <div className="Salt-Types-List-Conatiner-Row">
                                {Object.keys(saltData).map((saltType) => (
                                    <h2
                                        key={saltType}
                                        className={selectedSalt === saltType ? 'active-salt' : ''}
                                        onClick={() => setSelectedSalt(saltType)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {saltType}
                                    </h2>
                                ))}
                            </div>
                        </div>

                        <div className="Salt-Heading-Description-Container">
                            <div className="Salt-Row-Aline-Container">
                                <img
                                    src={saltData[selectedSalt].image}
                                    alt={selectedSalt}
                                    className="Salt-Type-Image"
                                />
                                <div className="Salt-Content-Container">
                                    <h1>{selectedSalt}</h1>
                                    <p>{saltData[selectedSalt].description}</p>
                                </div>
                            </div>


                        </div>
                    </div>
                    <Gettouch />
                </div>
            </div>



            <div className="Salt-Page-Mobile">
                <div className="Salt-Main-Container">
                    <div className="Salt-Sub-Container">
                        <h1>Salts</h1>
                        <p>Salt, also known as sodium chloride (NaCl), is one of
                            the most essential and widely used minerals on Earth.
                            More than just a seasoning, salt is a cornerstone of
                            life and industry. From maintaining the body’s
                            natural balance to enabling complex manufacturing
                            processes, its applications span far and wide.

                            At Chemi-Salt , we provide high-purity salt
                            products that are meticulously extracted, refined,
                            and quality-checked to meet the demands of a diverse range of industries.
                            Whether used in food production, pharmaceuticals, chemical manufacturing,
                            or agriculture, our salt delivers reliability, consistency, and superior performance.
                            We understand that not all salt is the same. That’s why we offer customized solutions based on grain size,
                            purity level, and packaging — ensuring every customer gets exactly what they need.

                        </p>

                        <h2>Types of Salts</h2>
                        <div className="Salt-Types-Card-Container-Mobile">
                            <h3>Refined Salt</h3>
                            <img src={crystalSaltImg} alt="crystalSaltImg" className="Salt-Type-Image" />
                            <p>
                                Refined Salt, also known as sodium chloride (NaCl), is one of the purest forms of salt.
                                Carefully processed and free from impurities, it is widely used in food production, pharmaceuticals,
                                and chemical manufacturing. This salt is essential for maintaining proper fluid balance in the body
                                and plays a vital role in various industrial applications. Our refined salt is available in various
                                grain sizes and packaging options, ensuring tailored solutions for every need.

                            </p>
                        </div>
                        <div className="Salt-Types-Card-Container-Mobile">
                            <h3>Crystal Salt</h3>
                            <img src={crystalSaltImg} alt="crystalSaltImg" className="Salt-Type-Image" />
                            <p>
                                Crystal Salt is naturally harvested from salt deposits,
                                known for its coarse texture and rich mineral content.
                                It retains trace minerals that give it a unique flavor and is often used as a finishing salt or in salt grinders.
                                The natural crystallization process makes it a preferred choice for
                                culinary enthusiasts and chefs who seek a more organic and flavorful
                                alternative to traditional salts. We specialize in providing premium-grade crystal salt for use in <strong>Textile Industry</strong> & <strong>RO Industry</strong>.

                            </p>
                        </div>
                        <div className="Salt-Types-Card-Container-Mobile">
                            <h3>Free Flow (medium)</h3>
                            <img src={freeFlowImg} alt="freeFlowImg" className="Salt-Type-Image" />
                            <p>
                                Free Flow (Medium) Salt is processed to prevent clumping, making it perfect for industrial packaging and applications.
                                Its flow-enhancing properties make it ideal for large-scale manufacturing, ensuring a smooth and consistent flow during production.
                                This type of salt is commonly used in food processing, packaging, and other industrial applications
                                where ease of handling is crucial. We specialize in providing premium-grade Free Flow C medium for use
                                in <strong>Soap Industry</strong> & <strong>Chemical Industry</strong>.

                            </p>
                        </div>
                        <div className="Salt-Types-Card-Container-Mobile">
                            <h3>Fine Salt</h3>
                            <img src={fineSaltImg} alt="fineSaltImg" className="Salt-Type-Image" />
                            <p>
                                Fine Salt has a smaller particle size, making it ideal for applications such as snacks, bakery products, and food seasonings.
                                Its fine texture allows it to dissolve quickly and evenly, enhancing the flavor of the food it is added to. This salt is
                                perfect for delicate recipes and is used in a wide range of culinary products.
                                We specialize in providing premium-grade Fine Salts for use in <strong>Chemical Industry</strong>.
                            </p>
                        </div>
                        <div className="Salt-Types-Card-Container-Mobile">
                            <h3>150 PPM Salt</h3>
                            <img src={ppm150Img} alt="ppm150Img" className="Salt-Type-Image" />
                            <p>
                                150 PPM Salt is specifically designed to meet the iodine deficiency needs in certain regions.
                                With 150 parts per million (PPM) of iodine, it is a critical resource for public health,
                                especially in areas where iodine deficiency is prevalent.
                                This salt helps prevent iodine deficiency disorders and ensures that people receive the necessary iodine intake for proper thyroid function.
                                We specialize in providing premium-grade 150 PPM Salt for use in <strong>Textile Industry</strong> & <strong>Dyes Industry</strong>.

                            </p>
                        </div>
                        <div className="Salt-Types-Card-Container-Mobile">
                            <h3>40 mesh Salt</h3>
                            <img src={mesh40} alt="mesh40" className="Salt-Type-Image" />
                            <p>
                                40 Mesh Salt is ground to a specific mesh size, commonly used in seasoning blends and processed foods.
                                Its granular texture is ideal for sprinkling over food products or blending into seasonings, ensuring a uniform distribution of salt.
                                This type of salt is commonly found in industrial kitchens, restaurants, and food production lines.
                            </p>
                        </div>
                        <div className="Salt-Types-Card-Container-Mobile">
                            <h3>50 PPM Salt</h3>
                            <img src={ppm50Img} alt="ppm50Img" className="Salt-Type-Image" />
                            <p>
                                50 PPM Salt is a type of salt with lower iodine content, typically used for specific dietary or industrial requirements.
                                It is perfect for customers seeking a salt with controlled iodine levels for customized health or manufacturing purposes.
                                This salt helps meet particular dietary needs without the high iodine concentration found in regular iodized salt.

                            </p>
                        </div>
                        <div className="Salt-Types-Card-Container-Mobile">
                            <h3>Iodised Salt</h3>
                            <img src={crystalSaltImg} alt="crystalSaltImg" className="Salt-Type-Image" />
                            <p>
                                Iodised Salt is enriched with iodine to help prevent iodine deficiency disorders,
                                commonly found in households and food manufacturing.
                                Iodine is an essential nutrient that supports thyroid health and metabolism.
                                This salt is widely used in homes, restaurants, and food production,
                                ensuring that individuals get their daily intake of iodine through a common dietary ingredient.
                            </p>
                        </div>
                    </div>


                    <Gettouch />
                </div>
            </div>
        </>
    )
}
export default Salts